import { Loading } from "@/components/Loading/SpinerLoading"
import { ComponentBlocksLongContent, useStaticPageQuery } from "@/gql/generated-types"
import { useRouter } from "next/router"
import { FC } from "react"

interface StaticPageProps {
  pageId: string
}

export const StaticPage: FC<StaticPageProps> = ({ pageId }) => {
  const { locale } = useRouter()
  const { data, loading } = useStaticPageQuery({ variables: { id: pageId, locale }, fetchPolicy: "network-only" })

  // @ts-ignore
  const block: ComponentBlocksLongContent | undefined | null = data?.page?.data?.attributes?.block?.find(
    e => e?.__typename === "ComponentBlocksLongContent",
  )

  if (loading) return <Loading isLoading />
  if (!block) return null
  return (
    <div>
      <div dangerouslySetInnerHTML={{ __html: block?.content ?? "" }} />
    </div>
  )
}
